import { render, staticRenderFns } from "./step3-build-specs.vue?vue&type=template&id=250e4786&scoped=true&"
import script from "./step3-build-specs.vue?vue&type=script&lang=js&"
export * from "./step3-build-specs.vue?vue&type=script&lang=js&"
import style0 from "./step3-build-specs.vue?vue&type=style&index=0&id=250e4786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e4786",
  null
  
)

export default component.exports